import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-bar-responsable-certificat-fcc',
  templateUrl: './side-bar-responsable-certificat-fcc.component.html',
  styleUrls: ['./side-bar-responsable-certificat-fcc.component.css'],
  animations: [
    trigger('slideToggle', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [animate('300ms ease-in-out')]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SideBarResponsableCertificatFccComponent implements OnInit {

  constructor(private router: Router) { }
  user: any | null;
  profil: any;
  logged: any;
  role!: any;
  cohorte!: string;

  sections = [
    { id: 1, isCollapsed: true },
    { id: 2, isCollapsed: true },
    { id: 3, isCollapsed: true },
    { id: 4, isCollapsed: true },
  ];
  ngOnInit() {
    this.user = sessionStorage.getItem('user');
    this.logged = sessionStorage.getItem('logged');
    this.profil = JSON.parse(this.user).profile.id;
    this.role = JSON.parse(this.user)?.roles;
    this.cohorte = JSON.parse(this.user).beneficiaryCohortes[0]?.cohorte.cohorteName;
    // console.log('user role: ', this.user);
  }

  reloadComponent(self: boolean, urlToNavigateTo?: string) {
    //skipLocationChange:true means dont update the url to / when navigating
    const url = self ? this.router.url : urlToNavigateTo;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        // console.log(`After navigation I am on:${this.router.url}`);
      });
    });
  }
  sessionChange(cohorte: string) {
    sessionStorage.setItem('cohorte', cohorte);
    this.router.navigate(['dashboard/appels/candidatures/' + cohorte]);
    setTimeout(() => {
      this.reloadComponent(false, 'dashboard/appels/candidatures/' + cohorte);
    }, 500);
  }
  openUrl(url: string) {
    window.open(url, '_blank');
  }

  toggleCollapse(id: number): void {
    const section = this.sections.find((sec) => sec.id === id);
    if (section) {
      section.isCollapsed = !section.isCollapsed;
    }
  }


}
